import moment from "moment";

const LISBON_TIME = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZone: "Europe/Lisbon",
});

const LISBON_DATE = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
  timeZone: "Europe/Lisbon",
});

const HOURS_PER_DAY = 24;
const MINUTES_PER_HOUR = 60;

export const formatObservedAt = (observedAt: string | null): string =>
  observedAt
    ? `${moment.utc(observedAt).format("D MMM YYYY, HH:mm")} UTC`
    : "never";

export const formatMarketDate = (date: string): string =>
  moment(date).format("D MMM YYYY");

export const formatLastRun = (lastRunAt: string | null): string =>
  `Last run ${formatObservedAt(lastRunAt)}`;

export const formatAgeHours = (ageHours: number): string => {
  if (ageHours < 1) {
    return "<1h";
  }
  const hours = Math.floor(ageHours);
  if (hours < HOURS_PER_DAY) {
    return `${hours}h`;
  }
  const days = Math.floor(hours / HOURS_PER_DAY);
  const rest = hours % HOURS_PER_DAY;
  return rest === 0 ? `${days}d` : `${days}d ${rest}h`;
};

export const formatInterval = (minutes: number): string =>
  minutes < MINUTES_PER_HOUR
    ? `${minutes} min`
    : formatAgeHours(minutes / MINUTES_PER_HOUR);

export const plural = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;

export const lisbonTime = (at: string): string =>
  LISBON_TIME.format(new Date(at));

export const lisbonDateLabel = (at: string): string =>
  LISBON_DATE.format(new Date(at));
